import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "@/views/stamford/HomeView.vue";
import StamfordTryeRange from "@/views/stamford/StamfordTryeRange.vue";
import PageNotFound from "@/views/stamford/PageNotFoundView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "stamford-home",
    component: HomeView,
  },
  {
    path: "/stamford-tyre-range",
    name: "stamford-tyre-range",
    component: StamfordTryeRange,
  },
  {
    path: '/404',
    name: 'page-not-found',
    component: PageNotFound
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/404"
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash }
    }

    if (from && Object.keys(to.query).length) {
      if (to.fullPath.split('?')[0] == from.fullPath.split('?')[0]) return;
    }

    return { top: 0, behavior: 'smooth' }; 
  }
});

router.afterEach(() => {
  const reCapthca = document.querySelector('.grecaptcha-badge') as any;
  if(router.currentRoute.value.name && (router.currentRoute.value.name !== 'stamford-home')) {
    if(reCapthca) {
      reCapthca.style.visibility = 'hidden';
    }
  } else {
    if(reCapthca) {
      reCapthca.style.visibility = `visible`;
    }
  }
});

export default router;
